import { TUserSources } from 'apps/user/types/user'

function removeHashAndAfter(str: string): string {
  const hashIndex = str.indexOf('#')
  if (hashIndex !== -1) {
    return str.substring(0, hashIndex)
  }

  return str
}

export function getUrlParams(search: string) {
  const noHashSearch = removeHashAndAfter(search)
  const searchParams = new URLSearchParams(noHashSearch)
  const params: { [key: string]: string } = {}
  for (const param of searchParams.entries()) {
    const [key, value] = param
    params[key] = value
  }

  return params
}

const SOURCE_TYPES: Record<TUserSources, string> = {
  carrier: 'Carrier App',
  shipper: 'Shipper App',
  marketplace: 'Stark',
}

export const getSourceValue = (source?: TUserSources) => (source ? SOURCE_TYPES[source] : '')
